<span><ng-content></ng-content></span>
<div class="ui-icon-close-circle"></div>
<div class="ui-icon-close-circle-filled icon-hover"></div>
